import styled from 'styled-components';

export const SpotifyConnectionBannerStyle = styled.div`
  .spotify-connection-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;
    background: linear-gradient(135deg, #1db954 0%, #1ed760 100%);
    color: white;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 100;
    width: 100%;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 12px;
      padding: 16px;
      text-align: center;
    }
  }

  .banner-content {
    display: flex;
    align-items: center;
    gap: 12px;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 8px;
    }

    svg {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
    }

    span {
      font-weight: 500;
      line-height: 1.4;
    }
  }

  .banner-actions {
    display: flex;
    gap: 12px;
    flex-shrink: 0;

    @media (max-width: 768px) {
      width: 100%;
      justify-content: center;
    }
  }

  .connect-btn {
    background: white;
    color: #1db954;
    border: none;
    padding: 8px 20px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }

    &:active {
      transform: scale(0.98);
    }

    @media (max-width: 768px) {
      flex: 1;
    }
  }

  .dismiss-btn {
    background: transparent;
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.5);
    padding: 8px 20px;
    border-radius: 20px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      border-color: white;
    }

    &:active {
      transform: scale(0.98);
    }

    @media (max-width: 768px) {
      flex: 1;
    }
  }
`;

